// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1a73e8","success":"#188038","edit":"#f80","error":"#bf360c","font":"#202124","link":"#045daf","italic":"#616161","disabled":"#202124"};